import { ICONS } from "./icons";
import { Reveal, SectionHead } from "./Reveal";

export const Features = ({ s, items }) => {
  if (!items.length) return null;
  return (
    <section id="diferenciais" data-testid="features-section" className="bg-[#08080A] py-24 lg:py-36 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <SectionHead label={s.features_label} title={s.features_title} subtitle={s.features_subtitle} testid="features-title" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/10">
          {items.map((f, i) => {
            const Icon = ICONS[f.icon] || ICONS.Star;
            return (
              <Reveal key={f.id} delay={(i % 3) * 0.1} className="border-r border-b border-white/10">
                <div className="group p-8 sm:p-10 lg:p-12 h-full transition-colors duration-500 hover:bg-white/[0.02]" data-testid={`feature-item-${i}`}>
                  <Icon className="w-7 h-7 text-[#CBD5E1] group-hover:text-[#C5A059] transition-colors duration-500" strokeWidth={1} />
                  <h3 className="mt-8 font-display text-2xl lg:text-3xl text-white">{f.title}</h3>
                  {f.text && <p className="mt-3 text-sm text-[#A1A1AA] leading-relaxed">{f.text}</p>}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
